module.exports = __webpack_public_path__ + "img/agri-sensor.013d351d.jpg";